import React, { useContext, useRef } from 'react';
import { MdKeyboardArrowDown } from 'react-icons/md';
import { AiOutlineUser } from 'react-icons/ai';
import { FiLock } from 'react-icons/fi';
import { IoIosLogOut } from 'react-icons/io';
import { useOutsideClick } from '@chakra-ui/hooks';
import { useTranslation } from 'react-i18next';
import { FaUserCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import * as S from './styles';
import { color } from 'styles/pallete';
import useWindowSize from 'hooks/useWindowSize';
import WindowSize from 'types/WindowSize';
import {
	logoutSystem,
	getObjOnLocalStorage,
	saveObjOnLocalStorage,
	deleteEpecificObjOnLocalStorage
} from 'utils/functions';
import { UserProps } from 'types/UserProps';
// import ChangeLanguage from 'components/ChangeLanguage';
import OptionsModalContext from 'context/OptionsModalContext';
import MyAccountContext from 'context/MyAccountContext';

export default function OptionsModal() {
	const modalRef = useRef(null);
	const navigate = useNavigate();

	const { isOpen: isOpenOptionsModal, setIsOpen: setIsOpenOptionsModal } =
		useContext(OptionsModalContext);
	const { setIsOpen: setIsOpenMyAccount } = useContext(MyAccountContext);

	const { width }: WindowSize = useWindowSize();
	const { t }: any = useTranslation();

	// Propriedades do DataLoginType podem ser indefinidas, por que se a pessoa não tiver logada pode ocorrer erro. Por isso estou setando valores iniciais.
	let userName = 'Desconhecido';
	let imageUser = '';

	// se não houver dados de login, o role continuara como 10 só para não bugar
	const userData: UserProps = getObjOnLocalStorage();
	if (userData) {
		userName = userData.firstName || 'Desconhecido';
		imageUser = '';
	}

	function cutFullName(name: string) {
		return name?.split(' ')[0] || 'Mondelez Pro Estático';
	}

	// função faz logout no sistema e salva o usuário no localstorage para jogar no campo de email do login
	function lockScreen() {
		const user = getObjOnLocalStorage();

		if (user !== null) {
			saveObjOnLocalStorage({ email: user.Email }, 'lockScreen');
			deleteEpecificObjOnLocalStorage('userData');
			navigate('/login');
		}
	}

	function closeModalTeste() {
		setIsOpenOptionsModal(false);
	}

	// responsável por fechar modal ao clicar fora do componente
	useOutsideClick({
		ref: modalRef,
		handler: () => closeModalTeste()
	});

	return (
		<S.container ref={modalRef}>
			<S.containerOpenModal
				onClick={() => {
					setIsOpenOptionsModal((value) => !value);
				}}
			>
				{typeof imageUser !== 'string' || imageUser === '' ? (
					<FaUserCircle
						style={{
							color: color.interface.darkgray2,
							fontSize: '30px',
							cursor: 'pointer'
						}}
					/>
				) : (
					<img src={imageUser} alt="avatar do usuário" />
				)}
				{width! > 1000 && (
					<>
						<S.title>
							{cutFullName(
								userName !== null || userName !== undefined || userName !== ''
									? userName
									: 'Desconhecido'
							)}
						</S.title>
						<S.button>
							<MdKeyboardArrowDown
								style={{
									color: color.interface.darkgray2,
									fontSize: '18px',
									cursor: 'pointer'
								}}
							/>
						</S.button>
					</>
				)}
			</S.containerOpenModal>

			{isOpenOptionsModal && (
				<S.contentModal>
					<S.welcome>{t('optionsModal.greetings')}!</S.welcome>

					<S.options>
						<S.option onClick={() => setIsOpenMyAccount(true)}>
							<AiOutlineUser
								style={{
									color: color.interface.darkgray,
									fontSize: '13px',
									cursor: 'pointer'
								}}
							/>
							<p>{t('optionsModal.myAccount')}</p>
						</S.option>

						<S.option onClick={() => lockScreen()}>
							<FiLock
								style={{
									color: color.interface.darkgray,
									fontSize: '13px',
									cursor: 'pointer'
								}}
							/>
							<p>{t('optionsModal.blockScreen')}</p>
						</S.option>

						{/* <S.option>
							<ChangeLanguage />
						</S.option> */}
					</S.options>

					<S.line />

					<S.logout onClick={() => logoutSystem()}>
						<IoIosLogOut
							style={{
								color: color.interface.darkgray,
								fontSize: '13px',
								cursor: 'pointer'
							}}
						/>
						<p>{t('optionsModal.logout')}</p>
					</S.logout>
				</S.contentModal>
			)}
		</S.container>
	);
}
